<template>
    <div id="app">
        <router-view></router-view>
        <audio id="bgm" loop preload="auto"><source src="./assets/bgm.mp3" type="audio/mpeg"></audio>
        <audio id="success" preload="auto"><source src="./assets/success.mp3" type="audio/mpeg"></audio>
        <audio id="beep" preload="auto"><source src="./assets/beep.mp3" type="audio/mpeg"></audio>
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style>
@font-face {
    font-family: 'GmarketSansBold';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansBold.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'GmarketSansMedium';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansMedium.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
#app {
    font-family: GmarketSansMedium, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body {
    margin: 0;
    padding: 0;
    background-color: #eFeFeF;
}
.highlight {
    background-color: #d5d5d5;
    border-radius: 3px;
    border: 2px #d5d5d5 solid;
    box-shadow: 2px 2px 2px #00000050;
    cursor:pointer;
}

.dialog {
    background-color: yellowgreen;
    margin: 10px 5px;
    padding: 5px;
    box-shadow: 0px 3px 3px yellowgreen;
}
.date {
    margin: 10px;
    color: grey;
    font-size: 16px;
    text-align: right;
}
.chat_room_title {
    border-bottom: 2px solid black;
    margin-bottom: 10px;
}


/* pc */
@media screen and (min-width: 415px) {
    .main_container {
        width: 1280px;
        /* height: 620px; */
        height: 100vh;
        margin: 0px;
        padding: 0px;
        overflow: auto;
        background-color: #eFeFeF;
    }

    .bottom_btn {
        width:500px;
        padding: 20px;
        left: calc(50vw - 250px);
        bottom: 10vh;
        border-radius: 10px;
        border: 2px solid black;
        font-size:30px;
        color: black;
        cursor:pointer;
    }
    .bottom_btn_container {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .bottom_one_btn {
        text-align: center;
        width: 400px;
        padding: 15px;
        border: 2px solid black;
        font-size:30px;
        color: black;
        cursor:pointer;
        font-weight: 700;
        background-color: white;
        box-shadow: 2px 2px 2px gray;
    }
    .view_title {
        text-align: center;
        color: black;
        font-weight: 700;
        font-size: 36px;
    }
    .article_title {
        background-color:white;
        height:50px;
        z-index: 1;
        margin-left:-10px;
        margin-top:10px;
        padding: 7px 25px;
        font-size:26px;
        font-weight:700;
    }
    .section_title {
        padding-top: 13px;
        text-align: center;
        color: white;
        font-size: 30px;
        font-weight: 700;
        width: 200px;
        height: 70px;
        background-repeat: no-repeat;
        background-image:url("assets/img/black_bg.png");
        background-size: 200px;
        z-index: 2;
    }

}


/* mobile */
@media screen and (max-width: 414px) {
    .main_container {
        width: 375px;
        /* height: 100vh; */
        min-height: calc(100vh - 0px);
        margin: 0px auto;
        padding: 0px;
        overflow: auto;
        background-color: #eFeFeF;
        /* background-color: blue; */
    }
    .bottom_btn_container {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .bottom_one_btn {
        text-align: center;
        width: 300px;
        padding: 15px;
        border: 2px solid black;
        font-size: 24px;
        color: black;
        cursor: pointer;
        font-weight: 700;
        background-color: white;
        box-shadow: 2px 2px 2px gray;
    }
    .view_title {
        display: none;
        /* text-align: center;
        color: black;
        font-weight: 700;
        font-size: 26px; */
    }
    .section_title {
        text-align: center;
        color: black;
        font-size: 26px;
        font-weight: 700;
    }

}






</style>
